import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Async thunk for fetching variations
export const fetchVariations = createAsyncThunk(
  'productVariations/fetchVariations',
  async (woocommerce_product_id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/getproductvariant/${woocommerce_product_id}`, { withCredentials: true });
      return response.data.data; // Return the data array of variations
    } catch (error) {
      console.log("Error from fetch variation: ", error.response?.data?.message);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch variations');
    }
  }
);

// Async thunk for adding a variation
export const addVariation = createAsyncThunk(
  'productVariations/addVariation',
  async (newVariation, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/createproductvariant', newVariation);
      return response.data;
    } catch (error) {
      console.log("Error from add variation: ", error.response?.data?.message);
      return rejectWithValue(error.response?.data?.message || 'Failed to add variation');
    }
  }
);

// Async thunk for updating a variation
export const updateVariation = createAsyncThunk(
  'productVariations/updateVariation',
  async ({ product_variant_id, updatedVariation }, { rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/updateproductvariant/${product_variant_id}`, updatedVariation);
      return response.data; // Assuming the API returns the updated variation
    } catch (error) {
      console.log("Error from update variation: ", error.response?.data?.message);
      return rejectWithValue(error.response?.data?.message || 'Failed to update variation');
    }
  }
);

export const deleteVariation = createAsyncThunk(
  'productVariations/deleteVariation',
  async ({ product_variant_id}, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`/api/deleteproductvariant/${product_variant_id}`);
      return response.data; // Assuming the API returns the updated variation
    } catch (error) {
      console.log("Error from update variation: ", error.response?.data?.message);
      return rejectWithValue(error.response?.data?.message || 'Failed to update variation');
    }
  }
);

const productVariationSlice = createSlice({
  name: 'productVariations',
  initialState: {
    variations: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchVariations
      .addCase(fetchVariations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVariations.fulfilled, (state, action) => {
        state.loading = false;
        state.variations = action.payload;
      })
      .addCase(fetchVariations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle addVariation
      .addCase(addVariation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addVariation.fulfilled, (state, action) => {
        state.loading = false;
        // Add the new variation to the existing variations
        state.variations.push(action.payload);
      })
      .addCase(addVariation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Handle updateVariation
      .addCase(updateVariation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateVariation.fulfilled, (state, action) => {
        state.loading = false;
        state.variations = action.payload; // Assuming API returns the updated list
      })
      
      .addCase(updateVariation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
//Handle Delete variations
.addCase(deleteVariation.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(deleteVariation.fulfilled, (state, action) => {
  state.loading = false;
  state.success = action.payload;
})
.addCase(deleteVariation.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
});

  },
});

export default productVariationSlice.reducer;
